export default {"src":"/_next/static/media/check_blue_narrow.6edf0ba2.svg","height":18,"width":21,"blurWidth":0,"blurHeight":0};